import api from '@/api'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import datepicker from 'vuejs-datepicker'
import { mapGetters } from 'vuex'
import NextCapitalAgentApprove from './NextCapitalAgentApprove.vue'
import { PAGE } from '../../../../constants/page'
import ReasonManage from './nt/ReasonManage.vue'

export default {
  props: {
    value: {
      default: null
    },
    loading: {
      default: true
    },
    livechat: {
      default: false
    },
    type: {
      default: 'edit'
    },
    isquickaddticket: {
      default: false
    }
  },
  components: {
    Multiselect,
    datepicker,
    NextCapitalAgentApprove,
    ReasonManage
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent'
    }),
    isJuzmatchCrm() {
      return PAGE.JUZMATCH_CRM.includes(this.selectedBot.pageid)
    },
    filterSubGroup() {
      if (this.ticket.group) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.ticket.group.id
        })
      } else {
        return []
      }
    },
    filterAgents() {
      if (this.ticket.group) {
        let agents = this.agents
          ? this.agents.filter((el) => {
              return el.admingroupid == this.ticket.group.id
            })
          : []
        if (this.ticket.subgroup) {
          agents = agents
            ? agents.filter((el) => {
                return el.adminsubgroupid == this.ticket.subgroup.id
              })
            : []
        }
        return agents
      } else {
        return this.agents ? this.agents : []
      }
    }
  },
  data() {
    return {
      currentStatus: null,
      ticket: {
        userid: null,
        firstname: null,
        lastname: null,
        email: null,
        phoneno: null,
        group: null,
        subgroup: null,
        subject: null,
        details: null,
        assignedTo: null,
        app: null,
        channel: null,
        status: 'pending',
        gender: null,
        address: null,
        priority: null,
        duedate: null,
        tags: null,
        contact_firstname: null,
        contact_lastname: null,
        contact_salary: null,
        contact_occupation: null,
        contact_phone: null,
        contact_email: null,
        kfc_order_amount: null,
        satisfaction_score: null,
        suggestion_note: null,
        panel: [false]
      },
      statusOptions: [
        'open',
        'pending',
        'answered',
        'closed',
        'cancelled',
        'cancelled by customer'
      ],
      genderOptions: ['male', 'female'],
      showManage: false,
      search: '',
      loadingTicket: false,
      items: [],
      select: null,
      groupOptions: [],
      subGroupOptions: [],
      tags: [],
      tagssearch: null,
      tagitems: [{ header: 'Select an option or create one' }],
      tagediting: null,

      priority: {
        text: 'Medium',
        value: 'medium'
      },
      priorityOptions: [
        {
          text: 'Low',
          value: 'low'
        },
        {
          text: 'Medium',
          value: 'medium'
        },
        {
          text: 'High',
          value: 'high'
        }
      ],
      appOptions: ['', 'phone', 'email', 'website', 'others'],

      duedate: {
        start: null,
        starttime: null
      },

      showDueDate: false,
      showDueTimeDialog: false,
      nextCapitalPage: ['105387828535129', '102549712095297'],
      selectedMenu: 'ticketInfo',
      dataAgentApprove: null,
      previousAssignGroupId: null,
      nt_reason: null
    }
  },
  async mounted() {
    if (this.value) {
      this.handleInitTicket()
    }
    if (this.value && this.value.status) {
      this.currentStatus = this.value.status
    }

    if (this.type == 'add' && this.isquickaddticket) {
      this.ticket = {
        ...this.ticket,
        firstname: this.value.first_name,
        lastname: this.value.last_name,
        channel: this.value.app,
        status: 'pending',
        userid: this.value.userid
      }
    }
    if (this.selectedBot.type === 'truecorp') {
      this.statusOptions.push('success')
    }
    if (this.selectedBot.theme === 'seagull') {
      this.statusOptions = [
        { name: 'pending', disabled: true },
        { name: 'answered', disabled: true },
        { name: 'closed' },
        { name: 'in progress', disabled: true },
        { name: 'cancelled', disabled: true },
        { name: 'cancelled by customer', disabled: true }
      ]
    }

    this.cached_ticket = JSON.stringify(this.ticket)
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
    tags(val, prev) {
      if (val.length === prev.length) return

      this.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v
          }

          this.tagitems.push(v)
        }

        return v
      })
    },
    value: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.handleInitTicket()
      }
    }
  },
  methods: {
    changeStatus(status) {
      if (status === 'closed' && this.currentStatus !== 'closed') {
        Object.assign(this.ticket, { is_send_survey: true })
      }
    },
    handleInitTicket() {
      this.ticket = {
        ...this.value,
        firstname: this.value.first_name,
        lastname: this.value.last_name,
        email: this.value.email,
        phoneno: this.value.phoneno,
        group: null,
        subgroup: null,
        subject: this.value.subject,
        details: this.value.details,
        assignedTo: null,
        channel: this.value.channel,
        status: this.value.status,
        gender: this.value.gender,
        address: this.value.address,
        priority: this.value.priority,
        duedate: this.value.duedate,
        tags: this.value.tags,
        contact_firstname: this.value.contact_firstname,
        contact_lastname: this.value.contact_lastname,
        contact_salary: this.value.contact_salary,
        contact_occupation: this.value.contact_occupation,
        contact_phone: this.value.contact_phone,
        contact_email: this.value.contact_email
      }
      if (this.value.duedate) {
        this.duedate.start = this.value.duedate
        this.duedate.starttime = moment(this.value.duedate).format('HH:mm')
      }

      if (this.value.assigngroupid) {
        var group = this.agentGroup.find((el) => {
          return el.id == this.value.assigngroupid
        })
        if (group) this.$set(this.ticket, 'group', group)
      }
      if (this.value.assignsubgroupid) {
        var subgroup = this.agentSubGroup.find((el) => {
          return el.id == this.value.assignsubgroupid
        })

        if (subgroup) this.$set(this.ticket, 'subgroup', subgroup)
      }
      if (this.value.assignadminid) {
        var agent =
          this.agents && this.agents.length
            ? this.agents.find((el) => {
                return el.adminid == this.value.assignadminid
              })
            : undefined
        if (agent) this.$set(this.ticket, 'assignedTo', agent)
      }

      if (this.value.priority) {
        this.priority = this.priorityOptions.find((el) => {
          return el.value == this.value.priority
        })
      }

      if (this.$store.state.oceanlifePage.includes(this.selectedBot.pageid)) {
        this.previousAssignGroupId = this.value.assigngroupid
      }

      try {
        if (this.value.tags) {
          var tags = this.value.tags.split(',')
          this.tags = tags.map((el) => {
            return { text: el }
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    onAssignInput(val) {
      if (val) {
        this.ticket.group = this.agentGroup.find((el) => el.id == val.admingroupid)
        this.ticket.subgroup = this.agentSubGroup.find((el) => el.id == val.adminsubgroupid)
      }
    },
    onSelectedDueDate: function (value) {
      var vm = this

      if (moment(this.duedate.end).isBefore(value)) {
        this.duedate.end = value
      }
      vm.duedate.start = value
      vm.showDueDate = false
    },
    async onChangeGroup(val) {
      this.ticket.subgroup = null
      this.ticket.assignedTo = null
    },

    async onChangeSubGroup(val) {
      this.ticket.assignedTo = null
    },
    async openModal() {
      this.showManage = true
      if (this.type == 'add') {
        this.loadingTicket = true
        try {
          this.items = await this.getLoadUsers()
        } catch (error) {
          console.error(error)
        }
        this.loadingTicket = false
      }
    },
    saveTicket(data) {
      return new Promise((resolve, reject) => {
        var request = data
        // console.log(request);
        api.postTickets(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editTicket(data) {
      return new Promise((resolve, reject) => {
        var request = {
          data: data,
          params: {
            id: data.id,
            pageid: data.pageid
          }
        }
        api.putTickets(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    onCancel() {
      this.showManage = false
      this.ticket = JSON.parse(this.cached_ticket)
      this.select = null
    },
    addUserManual(data) {
      return new Promise((resolve, reject) => {
        var request = data

        api.postUsersmanual(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editUserManual(data) {
      return new Promise((resolve, reject) => {
        var request = {
          data: data,
          params: {
            pageid: data.pageid,
            userid: data.userid
          }
        }
        api.putUsersmanual(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async onSave() {
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loadingTicket = true
      try {
        var data = {}
        if (this.type == 'add') {
          if (!this.ticket.userid) {
            var request = {
              ...this.ticket,
              pageid: this.selectedBot.pageid,
              first_name: this.ticket.firstname,
              last_name: this.ticket.lastname,
              email: this.ticket.email,
              phoneno: this.ticket.phoneno,
              gender: this.ticket.gender,
              app: this.ticket.app,
              channel: this.ticket.channel,
              address: this.ticket.address
            }

            var responseUser = await this.addUserManual(request)

            if (responseUser.data && responseUser.data.length > 0) {
              this.$set(this.ticket, 'userid', responseUser.data[0].id)
            }
          }

          if (this.ticket.userid) {
            data = {
              ...this.ticket,
              pageid: this.selectedBot.pageid,
              userid: this.ticket.userid,
              subject: this.ticket.subject,
              app: this.ticket.app,
              details: this.ticket.details,
              channel: this.ticket.channel,
              status: this.ticket.status,
              kfc_order_amount: this.ticket.kfc_order_amount,
              satisfaction_score: this.ticket.satisfaction_score,
              suggestion_note: this.ticket.suggestion_note,
              assigngroupid: this.ticket.group ? this.ticket.group.id : null,
              assignsubgroupid: this.ticket.subgroup ? this.ticket.subgroup.id : null,
              assignadminid: this.ticket.assignedTo ? this.ticket.assignedTo.adminid : null,

              priority: this.priority.value,
              duedate: this.duedate.start
                ? moment(this.duedate.start).format('YYYY-MM-DD ') +
                  (this.duedate.starttime ? this.duedate.starttime : '00:00')
                : null,
              tags: this.tags
                .map((el) => {
                  return el.text
                })
                .join(',')
            }

            if (this.$store.state.rabbitReplyFBPostPage.includes(this.selectedBot.pageid)) {
              data.postid = this.$store.state.rabbitSelectedPostId
            }

            var responseTicket = await this.saveTicket(data)
            if (responseTicket.data && responseTicket.data.length > 0) {
              this.$emit('addTicket', responseTicket.data[0])
            }
          }
        } else {
          //Edit
          var request = {
            ...this.ticket,
            userid: this.ticket.userid,
            pageid: this.selectedBot.pageid,
            first_name: this.ticket.firstname,
            last_name: this.ticket.lastname,
            gender: this.ticket.gender,
            app: this.ticket.app,
            email: this.ticket.email,
            phoneno: this.ticket.phoneno,
            address: this.ticket.address
          }
          if (!this.livechat) {
            var responseUser = await this.editUserManual(request)
          }
          data = {
            ...this.ticket,
            pageid: this.selectedBot.pageid,
            subject: this.ticket.subject,
            details: this.ticket.details,
            channel: this.ticket.channel,
            status: this.ticket.status,
            kfc_order_amount: this.ticket.kfc_order_amount,
            satisfaction_score: this.ticket.satisfaction_score,
            suggestion_note: this.ticket.suggestion_note,
            app: this.ticket.app,
            assigngroupid: this.ticket.group ? this.ticket.group.id : null,
            assignsubgroupid: this.ticket.subgroup ? this.ticket.subgroup.id : null,
            assignadminid: this.ticket.assignedTo ? this.ticket.assignedTo.adminid : null,

            priority: this.priority.value,
            duedate: this.duedate.start
              ? moment(this.duedate.start).format('YYYY-MM-DD ') +
                (this.duedate.starttime ? this.duedate.starttime : '00:00')
              : null,
            tags: this.tags
              .map((el) => {
                return el.text
              })
              .join(',')
          }

          if (this.$store.state.oceanlifePage.includes(this.selectedBot.pageid)) {
            if (this.previousAssignGroupId !== this.ticket.group.id) {
              data.previous_assigngroupid = this.previousAssignGroupId
            }
          }

          var responseTicket = await this.editTicket(data)
          // if (responseTicket.data && responseTicket.data.length > 0)
          //   this.$store.commit('UPDATE_CURRENT_USER_TICKET', data)
          if (data.status == 'closed') {
            this.$store.dispatch('loadLatestUsers', {
              type: this.$store.state.livechat.type
            })
          }
          this.$emit('editTicket', responseTicket.data[0])
        }
        this.showManage = false
        this.cached_ticket = JSON.stringify(this.ticket)
        this.select = null
      } catch (error) {
        console.error(error)
      }
      this.loadingTicket = false
    },
    onChangeSelect(val) {
      if (val) {
        this.$set(this.ticket, 'userid', val.id)
        this.$set(this.ticket, 'firstname', val.first_name)
        this.$set(this.ticket, 'lastname', val.last_name)
        this.$set(this.ticket, 'email', val.email)
        this.$set(this.ticket, 'phoneno', val.phoneno)
        this.$set(this.ticket, 'app', val.app)
        this.$set(this.ticket, 'channel', val.app)
      }
    },
    onClearCustomer() {
      this.select = null
      this.$set(this.ticket, 'userid', null)
      this.$set(this.ticket, 'firstname', null)
      this.$set(this.ticket, 'lastname', null)
      this.$set(this.ticket, 'email', null)
      this.$set(this.ticket, 'phoneno', null)
      this.$set(this.ticket, 'channel', null)
      this.$set(this.ticket, 'app', null)
    },
    async querySelections(v) {
      if (this.type == 'add') {
        this.loadingTicket = true
        var search = (v || '').toLowerCase()
        try {
          this.items = await this.getLoadUsers()
        } catch (error) {
          console.error(error)
        }
        this.loadingTicket = false
      }
    },
    getLoadUsers: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
          filter: {
            fullname: vm.search
          },
          limit: 25,
          offset: 0
        }

        api.getAllUsers(data, function (error, response) {
          if (error) {
            reject(error)
          }

          var users = response.data
          resolve(users)
        })
      })
    },
    tagsedit(index, item) {
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        this.tagediting = null
        this.index = -1
      }
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    getFullName(item) {
      return [item.first_name, item.last_name].join(' ')
    },
    selectedAgentApprove() {
      this.dataAgentApprove = {
        ticketId: this.ticket.id,
        status: this.ticket.status,
        type: this.ticket.json_variable.type,
        userid: this.ticket.userid,
        pageid: this.ticket.pageid,
        ...this.ticket.json_variable
      }
      this.selectedMenu = 'agentApprove'
    },
    handleUpdateReasonData(data) {
      this.nt_reason = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/ticket/ManageTicket.js